function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import * as o from 'react';
var ae = Object.defineProperty;
var R = Object.getOwnPropertySymbols;
var H = Object.prototype.hasOwnProperty,
  K = Object.prototype.propertyIsEnumerable;
var F = (e, t, n) => t in e ? ae(e, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[t] = n,
  m = (e, t) => {
    for (var n in t || (t = {})) H.call(t, n) && F(e, n, t[n]);
    if (R) {
      var _iterator = _createForOfIteratorHelper(R(t)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var n = _step.value;
          K.call(t, n) && F(e, n, t[n]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return e;
  };
var G = (e, t) => {
  var n = {};
  for (var c in e) H.call(e, c) && t.indexOf(c) < 0 && (n[c] = e[c]);
  if (e != null && R) {
    var _iterator2 = _createForOfIteratorHelper(R(e)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var c = _step2.value;
        t.indexOf(c) < 0 && K.call(e, c) && (n[c] = e[c]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return n;
};
var p = (e, t) => {
  let n = "[react-use-intercom]";
  switch (e) {
    case "info":
      console.log(`${n} ${t}`);
      break;
    case "warn":
      console.warn(`${n} ${t}`);
      break;
    case "error":
      console.error(`${n} ${t}`);
      break;
    default:
      console.log(`${n} ${t}`);
  }
};
var h = typeof window == "undefined",
  A = e => (Object.keys(e).forEach(t => {
    e[t] && typeof e[t] == "object" ? A(e[t]) : e[t] === void 0 && delete e[t];
  }), e);
var se = function (e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }
    if (!h && window.Intercom) return window.Intercom.apply(null, [e, ...t]);
    p("error", `${e} Intercom instance is not initalized yet`);
  },
  s = se;
var ce = /*#__PURE__*/o.createContext(void 0),
  P = ce;
var ie = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var n = window,
      c = n.Intercom;
    if (typeof c == "function") c("reattach_activator"), c("update", n.intercomSettings);else {
      var w = document,
        l = function () {
          l.c(arguments);
        };
      l.q = [], l.c = function (u) {
        l.q.push(u);
      }, n.Intercom = l;
      var f = function () {
        setTimeout(function () {
          var u = w.createElement("script");
          u.type = "text/javascript", u.async = !0, u.src = "https://widget.intercom.io/widget/" + e;
          var d = w.getElementsByTagName("script")[0];
          d.parentNode.insertBefore(u, d);
        }, t);
      };
      document.readyState === "complete" ? f() : n.attachEvent ? n.attachEvent("onload", f) : n.addEventListener("load", f, !1);
    }
  },
  X = ie;
var me = e => ({
    custom_launcher_selector: e.customLauncherSelector,
    alignment: e.alignment,
    vertical_padding: e.verticalPadding,
    horizontal_padding: e.horizontalPadding,
    hide_default_launcher: e.hideDefaultLauncher,
    session_duration: e.sessionDuration,
    action_color: e.actionColor,
    background_color: e.backgroundColor
  }),
  Y = e => m({
    company_id: e.companyId,
    name: e.name,
    created_at: e.createdAt,
    plan: e.plan,
    monthly_spend: e.monthlySpend,
    user_count: e.userCount,
    size: e.size,
    website: e.website,
    industry: e.industry
  }, e.customAttributes),
  le = e => ({
    type: e.type,
    image_url: e.imageUrl
  }),
  ue = e => {
    var t;
    return m({
      email: e.email,
      user_id: e.userId,
      created_at: e.createdAt,
      name: e.name,
      phone: e.phone,
      last_request_at: e.lastRequestAt,
      unsubscribed_from_emails: e.unsubscribedFromEmails,
      language_override: e.languageOverride,
      utm_campaign: e.utmCampaign,
      utm_content: e.utmContent,
      utm_medium: e.utmMedium,
      utm_source: e.utmSource,
      utm_term: e.utmTerm,
      avatar: e.avatar && le(e.avatar),
      user_hash: e.userHash,
      company: e.company && Y(e.company),
      companies: (t = e.companies) == null ? void 0 : t.map(Y)
    }, e.customAttributes);
  },
  b = e => A(m(m({}, me(e)), ue(e)));
var de = we => {
    var k = we,
      e = k.appId,
      _k$autoBoot = k.autoBoot,
      t = _k$autoBoot === void 0 ? !1 : _k$autoBoot,
      n = k.autoBootProps,
      c = k.children,
      w = k.onHide,
      l = k.onShow,
      f = k.onUnreadCountChange,
      u = k.onUserEmailSupplied,
      _k$shouldInitialize = k.shouldInitialize,
      d = _k$shouldInitialize === void 0 ? !h : _k$shouldInitialize,
      v = k.apiBase,
      ee = k.initializeDelay,
      te = G(k, ["appId", "autoBoot", "autoBootProps", "children", "onHide", "onShow", "onUnreadCountChange", "onUserEmailSupplied", "shouldInitialize", "apiBase", "initializeDelay"]);
    let g = o.useRef(!1),
      y = o.useRef(!1),
      _ = Object.keys(te).filter(r => !r.startsWith("data-"));
    _.length > 0 && p("warn", ["some invalid props were passed to IntercomProvider. ", `Please check following props: ${_.join(", ")}.`].join(""));
    let C = o.useCallback(r => {
        if (!window.Intercom && !d) {
          p("warn", "Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");
          return;
        }
        let i = m(m({
          app_id: e
        }, v && {
          api_base: v
        }), r && b(r));
        window.intercomSettings = i, s("boot", i), g.current = !0;
      }, [v, e, d]),
      _o$useState = o.useState(!1),
      _o$useState2 = _slicedToArray(_o$useState, 2),
      x = _o$useState2[0],
      I = _o$useState2[1],
      oe = o.useCallback(() => {
        I(!1), w && w();
      }, [w, I]),
      re = o.useCallback(() => {
        I(!0), l && l();
      }, [l, I]);
    !h && d && !y.current && (X(e, ee), s("onHide", oe), s("onShow", re), s("onUserEmailSupplied", u), f && s("onUnreadCountChange", f), t && C(n), y.current = !0);
    let a = o.useCallback((r, i) => {
        if (!window.Intercom && !d) {
          p("warn", "Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");
          return;
        }
        if (!g.current) {
          p("warn", [`"${r}" was called but Intercom has not booted yet. `, `Please call 'boot' before calling '${r}' or `, "set 'autoBoot' to true in the IntercomProvider."].join(""));
          return;
        }
        return i();
      }, [d]),
      S = o.useCallback(() => {
        g.current && (s("shutdown"), delete window.intercomSettings, g.current = !1);
      }, []),
      D = o.useCallback(() => {
        g.current && (s("shutdown"), delete window.Intercom, delete window.intercomSettings, g.current = !1);
      }, []),
      M = o.useCallback(() => {
        a("update", () => {
          let r = Math.floor(new Date().getTime() / 1e3);
          s("update", {
            last_request_at: r
          });
        });
      }, [a]),
      E = o.useCallback(r => {
        a("update", () => {
          if (!r) {
            M();
            return;
          }
          let i = b(r);
          window.intercomSettings = m(m({}, window.intercomSettings), i), s("update", i);
        });
      }, [a, M]),
      T = o.useCallback(() => {
        a("hide", () => {
          s("hide");
        });
      }, [a]),
      $ = o.useCallback(() => {
        a("show", () => s("show"));
      }, [a]),
      N = o.useCallback(() => {
        a("showMessages", () => {
          s("showMessages");
        });
      }, [a]),
      V = o.useCallback(r => {
        a("showNewMessage", () => {
          r ? s("showNewMessage", r) : s("showNewMessage");
        });
      }, [a]),
      z = o.useCallback(() => a("getVisitorId", () => s("getVisitorId")), [a]),
      L = o.useCallback(r => {
        a("startTour", () => {
          s("startTour", r);
        });
      }, [a]),
      q = o.useCallback(r => {
        a("startChecklist", () => {
          s("startChecklist", r);
        });
      }, [a]),
      O = o.useCallback((r, i) => {
        a("trackEvent", () => {
          i ? s("trackEvent", r, i) : s("trackEvent", r);
        });
      }, [a]),
      B = o.useCallback(r => a("showArticle", () => {
        s("showArticle", r);
      }), [a]),
      U = o.useCallback(r => a("showSpace", () => {
        s("showSpace", r);
      }), [a]),
      W = o.useCallback(r => {
        a("startSurvey", () => {
          s("startSurvey", r);
        });
      }, [a]),
      j = o.useCallback(r => a("showNews", () => {
        s("showNews", r);
      }), [a]),
      ne = o.useMemo(() => ({
        boot: C,
        shutdown: S,
        hardShutdown: D,
        update: E,
        hide: T,
        show: $,
        isOpen: x,
        showMessages: N,
        showNewMessage: V,
        getVisitorId: z,
        startTour: L,
        startChecklist: q,
        trackEvent: O,
        showArticle: B,
        startSurvey: W,
        showSpace: U,
        showNews: j
      }), [C, S, D, E, T, $, x, N, V, z, L, q, O, B, W, U, j]);
    return /*#__PURE__*/o.createElement(P.Provider, {
      value: ne
    }, c);
  },
  Z = () => {
    let e = o.useContext(P);
    if (e === void 0) throw new Error('"useIntercom" must be used within `IntercomProvider`.');
    return e;
  };
var pe = () => Z();
export { de as IntercomProvider, pe as useIntercom };